// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__186xU","active":"downloadDropdown_active__21bvJ"};